import { BaseMediaService } from '../../base-media.service';
// import { MediaSaveRequestDto } from '../dto/request/media-save-request';
import { MediaSaveResponseDto } from '../dto/response/media-save-response';

class MediaService extends BaseMediaService {
  public async saveMedia(media: FormData): Promise<MediaSaveResponseDto> {
    const response = await this.post<MediaSaveResponseDto>(`/media`, media, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }

  public async deleteMedia(fileName: string): Promise<void> {
    await this.delete<void>('/media', {
      params: {
        fileName,
      },
    });
  }
}

const mediaService = new MediaService();
export default mediaService;
